module.exports = __webpack_public_path__ + "img/product-placeholder-75.85e86c5.png";